import React, { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import Wrapper from './styled';
import BooleanField from './BooleanField';
import { useSelector, useDispatch } from 'react-redux';
import { selectTriggerIgnoreInfo, selectTriggerResolveHostname } from 'store/Agents/selectors';
import { setIgnoreInfo, setIgnoreInfoInDetail, setResolveHostname, setResolveHostnameInDetail } from 'store/Agents/actions';
import { useIntl } from 'react-intl';

const ExecutionParams = ({ currentTool, disabled, runStatusLog }) => {
  const initialIgnoreInfo = get(currentTool, 'ignore_info', false);
  const initialResolveHostname = get(currentTool, 'resolve_hostname', false);
  const intl = useIntl();
  const dispatch = useDispatch();
  const ignoreInfo = useSelector((state) => selectTriggerIgnoreInfo(state, get(currentTool, 'id', 0)));
  const resolveHostname = useSelector((state) => selectTriggerResolveHostname(state, get(currentTool, 'id', 0)));
  const ignoreInfoLabel = intl.formatMessage({ id: 'agents.triggerAgent.ignoreInfo' });
  const resolveHostnameLabel = intl.formatMessage({ id: 'agents.triggerAgent.resolveHostnames' });
  const defaultIgnoreInfo = runStatusLog ? initialIgnoreInfo : ignoreInfo;
  const defaultResolveHostName = runStatusLog ? initialResolveHostname : resolveHostname;

  useEffect(() => {
    if (runStatusLog) {
      dispatch(setIgnoreInfo(initialIgnoreInfo));
      dispatch(setResolveHostname(initialResolveHostname));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const onChangeIgnoreInfo = (checked, currentTool) => {
    if (runStatusLog) dispatch(setIgnoreInfo(checked));
    else dispatch(setIgnoreInfoInDetail(checked, currentTool));
  };

  const onChangeResolveHostname = (checked, currentTool) => {
    if (runStatusLog) dispatch(setResolveHostname(checked));
    else dispatch(setResolveHostnameInDetail(checked, currentTool));
  };

  if (isEmpty(currentTool)) return null;
  return (
    <Wrapper>
      <BooleanField defaultValue={ defaultIgnoreInfo } param={ ignoreInfoLabel } onChange={ (checked) => onChangeIgnoreInfo(checked, currentTool) } disabled={ disabled } />
      <BooleanField defaultValue={ defaultResolveHostName } param={ resolveHostnameLabel } onChange={ (checked) => onChangeResolveHostname(checked, currentTool) } disabled={ disabled } />
    </Wrapper>
  );
};

export default ExecutionParams;
